import { AccessMode } from '@constants/generic';
import { Org } from 'types/organization';

/** Churn arrives as its own flag on the org list, not as an `access_mode`. */
export const isOrgChurned = (org?: Org | null): boolean =>
  Boolean(org?.is_churned);

/**
 * An org the user cannot operate in — blacklisted or churned. Both are gated
 * identically, so access checks should use this instead of comparing
 * `access_mode` directly.
 */
export const isOrgRestricted = (org?: Org | null): boolean =>
  org?.access_mode === AccessMode.BLACKLISTED || isOrgChurned(org);
